import type { SVGProps } from 'react';
export const Account = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M10 4.84a3.44 3.44 0 0 0-3.5 3.39A3.44 3.44 0 0 0 10 11.6c1.94 0 3.5-1.53 3.5-3.38A3.44 3.44 0 0 0 10 4.84m2.78 7.26a4.7 4.7 0 0 0 2.07-3.87A4.8 4.8 0 0 0 10 3.5a4.8 4.8 0 0 0-4.85 4.73c0 1.6.82 3.01 2.07 3.87a8 8 0 0 0-4.13 3.39.67.67 0 0 0 .24.92c.33.19.74.08.93-.24a6.5 6.5 0 0 1 2.42-2.35 6.8 6.8 0 0 1 9.06 2.35c.19.32.6.43.93.24.32-.2.43-.6.24-.92a8 8 0 0 0-4.13-3.4"
      clipRule="evenodd"
    />
  </svg>
);
